const baseUrl = 'api/drsp_elf'
const operationBaseUrl = 'api/drsp_operation'
const devOpsBaseUrl = 'api/drsp_dev_ops'
const assetBaseUrl = 'api/drsp_asset'
export default {
  // 获取工单列表
  orderList: { url: `${baseUrl}/order/list`, method: 'post' },
  //工单事件
  orderEvents: { url: `${baseUrl}/order/all_event/list`, method: 'get' },
  //工单详情
  orderDetail: { url: `${baseUrl}/repair/order/detail`, method: 'get' },
  // 获取服务提供商树
  providerChildTree: { url: `${baseUrl}/provider/child_tree`, method: 'get' },
  // 获取服务提供商树
  customerTree: { url: `${baseUrl}/customer/tree`, method: 'get' },
  // 服务场景内容列表
  serviceSceneContentList: { url: `${baseUrl}/serviceScene/content/list`, method: 'post' },
  // 用户列表
  operationUserList: { url: `${operationBaseUrl}/user/list`, method: 'post' },
  // 角色列表
  roleList: { url: `${operationBaseUrl}/role/list`, method: 'get' },

  // 规则分页
  rulePage: { url: `${devOpsBaseUrl}/rule/page`, method: 'post' },
  // 创建规则
  ruleCreate: { url: `${devOpsBaseUrl}/rule/create`, method: 'post' },
  // 删除规则
  ruleDelete: { url: `${devOpsBaseUrl}/rule/delete`, method: 'post' },
  // 更新规则
  ruleModify: { url: `${devOpsBaseUrl}/rule/modify`, method: 'post' },
  // 获取规则详情
  ruleDetail: { url: `${devOpsBaseUrl}/rule/detail_with_id`, method: 'get' },
  // 规则停用/启用
  ruleUpdateStatus: { url: `${devOpsBaseUrl}/rule/update_status`, method: 'post' },
  // 规则预览
  rulePreview: { url: `${devOpsBaseUrl}/rule/preview`, method: 'post' },
  // 异常事件统计
  alarmStatisticsEvent: { url: `${devOpsBaseUrl}/rule/alarm/statistics/event`, method: 'post' },
  // 规则告警异常类型统计
  alarmStatisticsExceptionType: { url: `${devOpsBaseUrl}/rule/alarm/statistics/exception_type`, method: 'post' },
  // 异常预警处理
  alarmHandle: { url: `${devOpsBaseUrl}/alarm/handle`, method: 'post' },
  // 分页异常预警
  alarmPage: { url: `${devOpsBaseUrl}/alarm/page`, method: 'post' },
  // 新增异常类别
  exceptionTypeCreate: { url: `${devOpsBaseUrl}/exception_type/create`, method: 'post' },
  // 删除异常类别
  exceptionTypeDelete: { url: `${devOpsBaseUrl}/exception_type/delete`, method: 'post' },
  // 获取异常类型下拉列表
  exceptionTypeList: { url: `${devOpsBaseUrl}/exception_type/list`, method: 'post' },
  // 修改异常类别
  exceptionTypeModify: { url: `${devOpsBaseUrl}/exception_type/modify`, method: 'post' },
  // 分页查询异常类型
  exceptionTypePage: { url: `${devOpsBaseUrl}/exception_type/page`, method: 'post' },
  // 获取异常预警详情
  alarmDetail: { url: `${devOpsBaseUrl}/alarm/detail_with_id`, method: 'get' },
  // 获取厂商列表
  manufacturerList: { url: `${assetBaseUrl}/manufacturer/list`, method: 'post' },
  // 获取产品列表
  productList: { url: `${assetBaseUrl}/product/list`, method: 'post' },
}